import { gql } from "@apollo/client";
import { ImageFragment } from "../../fragments/image";

export const QUERY_ABOUT_PAGE = gql`
  query aboutPage {
    aboutPage {
      data {
        id
        attributes {
          pageTitle
          DefaultContentTemplate {
            __typename
            ... on ComponentCommonH3 {
              text
            }
            ... on ComponentCommonMedia {
              media {
                data {
                  attributes {
                    url
                    alternativeText
                  }
                }
              }
            }
            ... on ComponentCommonTitle {
              title
            }

            ... on ComponentCommonAuthor {
              author {
                data {
                  attributes {
                    name
                  }
                }
              }
              publicationDate
            }

            ... on ComponentCommonAuthorDetailed {
              authors: authors_connection {
                data {
                  attributes {
                    name
                    role
                    bio
                    avatar {
                      data {
                        ...ImageFragment
                      }
                    }
                  }
                }
              }
            }

            ... on ComponentCommonDivider {
              id
            }

            ... on ComponentCommonEmbedded {
              link
              provider
            }

            ... on ComponentCommonTextEditor {
              markdownText
            }

            ... on ComponentCommonEmbedded {
              link
              provider
            }

            ... on ComponentCommonBullet {
              item {
                text
              }
            }

            ... on ComponentCommonQuote {
              quote
            }

            ... on ComponentCommonFaqComponent {
              faq {
                title
                description
              }
            }

            ... on ComponentCommonDownloadableContentList {
              list {
                id
                title
                description
                content {
                  data {
                    attributes {
                      url
                    }
                  }
                }
              }
            }
          }
        }
      }
    }
  }
  ${ImageFragment}
`;
